/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TransferCoachWithCoachAndTeam = {
    properties: {
        team_to_id: {
            type: 'number',
            isRequired: true,
        },
        team_from_id: {
            type: 'number',
            isRequired: true,
        },
        coach_id: {
            type: 'number',
            isRequired: true,
        },
        coach_type: {
            type: 'CoachTypeEnum',
            isRequired: true,
        },
        coach: {
            type: 'any-of',
            contains: [{
                type: 'CoachSmall',
            }, {
                type: 'null',
            }],
        },
        team_to: {
            type: 'any-of',
            contains: [{
                type: 'TeamSmall',
            }, {
                type: 'null',
            }],
        },
        team_from: {
            type: 'any-of',
            contains: [{
                type: 'TeamSmall',
            }, {
                type: 'null',
            }],
        },
    },
} as const;
